import gql from 'graphql-tag';

export const GET_TEMPLATES = gql`
  query GetTemplates($input: BPFTemplatesInput!, $parentId: ID, $parentType: BPFLinkType) {
    bpf {
      templates(input: $input, parentId: $parentId, parentType: $parentType) {
        department {
          id
          name
        }
        templates {
          name
          isActive
          accountId
          createdDateTime
          modifiedDateTime
          businessProcessFlowId
          department {
            id
            name
          }
          stages {
            name
            ordinal
            stageFields
            completionRules
            businessProcessFlowId
            businessProcessFlowStageId
            fieldValues(parentId: $parentId, parentType: $parentType) {
              id
              values
              isCompleted
              completedById
              completedDateTime
              completedBy {
                id
                fullName
              }
            }
          }
        }
      }
    }
  }
`;
